/**
 * Given an array of toasts for a specific position.
 * It returns the toast that matches the `id` passed
 */

/**
 * The default options for toast
 * - 5 seconds, solid grey, displayed on the bottom.
 */
var defaults = {
  duration: 5000,
  position: 'bottom',
  variant: 'solid'
};
/**
 * Given the toast manager state, finds the toast that matches
 * the id and return its position and index
 */
function findToast(toasts, id) {
  var position = getToastPosition(toasts, id);
  var index = position ? toasts[position].findIndex(function (toast) {
    return toast.id === id;
  }) : -1;
  return {
    position: position,
    index: index
  };
}

/**
 * Given the toast manager state, finds the position of the toast that
 * matches the `id`
 */
var getToastPosition = function getToastPosition(toasts, id) {
  var _Object$values$flat$f;
  return (_Object$values$flat$f = Object.values(toasts).flat().find(function (toast) {
    return toast.id === id;
  })) === null || _Object$values$flat$f === void 0 ? void 0 : _Object$values$flat$f.position;
};

/**
 * Get's the styles to be applied to a toast's container
 * based on its position in the manager
 */
function getToastStyle(position) {
  var isRighty = position.includes('right');
  var isLefty = position.includes('left');
  var alignItems = 'center';
  if (isRighty) alignItems = 'flex-end';
  if (isLefty) alignItems = 'flex-start';
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: alignItems
  };
}
function getToastListStyle(position, options) {
  var _ref = options !== null && options !== void 0 ? options : {},
    relative = _ref.relative,
    offset = _ref.offset;
  var isTopOrBottom = position === 'top' || position === 'bottom';
  var margin = isTopOrBottom ? '0 auto' : undefined;
  var height;
  var alignItems;
  var justifyContent;
  var applyOffset = function applyOffset(value, offset) {
    return typeof offset === 'string' && typeof value === 'string' ? "calc(".concat(offset, " + ").concat(value, ")") : value;
  };
  var top = position.includes('top') ? 'env(safe-area-inset-top, 0px)' : position.includes('center') ? '50%' : undefined;
  var bottom = position.includes('bottom') ? 'env(safe-area-inset-bottom, 0px)' : undefined;
  var right = !['center', 'left'].some(function (i) {
    return position.includes(i);
  }) ? 'env(safe-area-inset-right, 0px)' : undefined;
  var left = position.includes('center') ? '50%' : !position.includes('right') ? 'env(safe-area-inset-left, 0px)' : undefined;
  var transform = position.includes('center') ? 'translate(-50%, -50%)' //center around toasts center point instead of toasts left/top edges
  : undefined;
  return {
    position: relative ? 'relative' : 'fixed',
    zIndex: 10001,
    pointerEvents: 'none',
    display: 'flex',
    flexDirection: 'column',
    margin: margin,
    top: applyOffset(top, offset === null || offset === void 0 ? void 0 : offset.top),
    bottom: applyOffset(bottom, offset === null || offset === void 0 ? void 0 : offset.bottom),
    right: applyOffset(right, offset === null || offset === void 0 ? void 0 : offset.right),
    left: applyOffset(left, offset === null || offset === void 0 ? void 0 : offset.left),
    height: height,
    alignItems: alignItems,
    justifyContent: justifyContent,
    transform: transform
  };
}

export { defaults, findToast, getToastListStyle, getToastPosition, getToastStyle };
//# sourceMappingURL=toast.utils.esm.js.map
